import * as React from 'react'
import { Link } from 'gatsby'
import DropdownMenuLink from '../HomeMenu/DropdownMenuLink'
import BrandLetterSelector from '../HomeMenu/BrandLetterSelector'
import DropdownMenuContainer from './DropdownMenuContainer'
import PropTypes from 'prop-types'

const WatchDropDownMenu = ({ dropDown, onMenuLinkClick, setDropDown }) => {
  return (
    <DropdownMenuContainer selectedDropDown={dropDown} dropDownIndex={1} setDropDown={setDropDown}>
      <div>
        <div className="w-[calc(100vw-3em)] md:w-[calc(100vw-11.25rem)] sticky font-bold text-red-600 top-0 bg-white justify-between items-center mb-2 left-0 h-14 flex flex-row border-b lg:hidden">
          LUXURY WATCHES
          <Link
            to="/fine-watches/"
            onClick={onMenuLinkClick}
            className="lg:hidden text-sm py-4 px-5 text-gray-600 font-normal underline underline-offset-2 decoration-slate-300 "
          >
            See All
            <span className="sr-only">Luxury Watches</span>
          </Link>
        </div>
        <Link
          onClick={onMenuLinkClick}
          to="/fine-watches/"
          className="text-black lg:border-transparent lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold lg:hover:text-red-700 mt-4 block font-bold lg:mt-0  "
        >
          TOP BRANDS
        </Link>
        <div className="flex flex-col">
          <DropdownMenuLink to="/fine-watches/rolex/" onClick={onMenuLinkClick}>
            Rolex
          </DropdownMenuLink>
          <DropdownMenuLink to="/fine-watches/cartier/" onClick={onMenuLinkClick}>
            Cartier
          </DropdownMenuLink>
          <DropdownMenuLink to="/fine-watches/patek-philippe/" onClick={onMenuLinkClick}>
            Patek Philippe
          </DropdownMenuLink>
          <DropdownMenuLink to="/fine-watches/audemars-piguet/" onClick={onMenuLinkClick}>
            Audemars Piguet
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/fine-watches/other-watches-brands/omega/"
            onClick={onMenuLinkClick}
          >
            Omega
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/fine-watches/other-watches-brands/breitling/"
            onClick={onMenuLinkClick}
          >
            Breitling
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/fine-watches/other-watches-brands/jaeger-lecoultre/"
            onClick={onMenuLinkClick}
          >
            Jaeger LeCoultre
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/fine-watches/other-watches-brands/hublot/"
            onClick={onMenuLinkClick}
          >
            Hublot
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/fine-watches/other-watches-brands/ulysse-nardin/"
            onClick={onMenuLinkClick}
          >
            Ulysse Nardin
          </DropdownMenuLink>
          <DropdownMenuLink to="/all-watch-brands/" onClick={onMenuLinkClick}>
            VIEW ALL BRANDS
          </DropdownMenuLink>
        </div>
      </div>
      <BrandLetterSelector onMenuLinkClicked={onMenuLinkClick} />
      <div className=" ">
        <Link
          onClick={onMenuLinkClick}
          to="/fine-watches/pocket-watches-for-sale/"
          className=" py-3 lg:border-transparent lg:py-0 lg:text-sm lg:hover:font-bold text-black lg:hover:text-red-600 block w-full font-bold lg:mt-0"
        >
          POCKET WATCHES
        </Link>
        <Link
          onClick={onMenuLinkClick}
          to="/fine-watches/vintage-watches/"
          className=" py-3 lg:border-transparent lg:py-0 lg:text-sm lg:hover:font-bold text-black lg:hover:text-red-600 block w-full font-bold lg:mt-0"
        >
          VINTAGE WATCHES
        </Link>
        <Link
          onClick={onMenuLinkClick}
          to="/fine-watches/with-box-and-papers/"
          className=" py-3 lg:border-transparent lg:py-0 lg:text-sm lg:hover:font-bold text-black lg:hover:text-red-600 block w-full font-bold lg:mt-0"
        >
          WATCHES WITH BOX AND PAPERS
        </Link>
        <Link
          onClick={onMenuLinkClick}
          to="/accessories/"
          className="text-black lg:text-black lg:hover:text-red-600 font-bold block  py-3 lg:border-transparent lg:py-0 lg:text-sm lg:hover:font-bold"
        >
          ACCESSORIES
        </Link>
        <div className="hidden lg:grid lg:grid-flow-row">
          <DropdownMenuLink to="/accessories/watchwinders/" onClick={onMenuLinkClick}>
            Watch Winders
          </DropdownMenuLink>
          <DropdownMenuLink to="/watch-bands/" onClick={onMenuLinkClick}>
            Watch Bands & Straps
          </DropdownMenuLink>
          <DropdownMenuLink to="/accessories/dials/" onClick={onMenuLinkClick}>
            Watch Dials
          </DropdownMenuLink>
        </div>
        <div className="bg-gray-100 lg:bg-transparent lg:pt-5">
          <Link
            onClick={onMenuLinkClick}
            to="/repairs/"
            className=" py-3 text-black lg:border-transparent lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold lg:hover:text-red-700 font-bold block"
          >
            ADDITIONAL <span className="sr-only">WATCH</span> LINKS
          </Link>

          <div className=" flex flex-col w-full bg-red-">
            <a
              className={
                ' py-3 lg:border-transparent lg:py-0 lg:text-sm text-gray-700 lg:hover:font-bold lg:hover:text-red-700 indent-5 lg:indent-0'
              }
              href="https://sellusyourjewelry.com/?utm_source=referral&utm_medium=grayandsons"
              rel={'noopener'}
            >
              Sell Your Watch
            </a>
            <DropdownMenuLink to="/repairs/" onClick={onMenuLinkClick}>
              Watch Repair Blogs
            </DropdownMenuLink>
          </div>
        </div>
      </div>
    </DropdownMenuContainer>
  )
}
WatchDropDownMenu.propTypes = {
  dropDown: PropTypes.number,
  onMenuLinkClick: PropTypes.func,
  setDropDown: PropTypes.func,
}

export default WatchDropDownMenu
